import React, { useEffect, useMemo } from 'react';
import { useTranslate } from '@im/react-localization';
import { Vendor } from '../../hooks/vendor-search';
import {
  useVendorsSearchQuery,
  PRICE_CONSTS,
} from '../../hooks/singlePricingSearch';
import CustomSearchBar from './CustomSearchBar';

type VendorSearchBarType = {
  onValueSelected: (value: Vendor | null) => void;
  searchQuery: any;
  setFilter: (value?: any) => void;
  value: any;
};
export default function VendorSearchBar({
  onValueSelected,
  searchQuery,
  setFilter,
  value,
}: Readonly<VendorSearchBarType>) {
  const translate = useTranslate();
  const { data: { list } = {}, isLoading } = useVendorsSearchQuery({
    ...searchQuery,
  });

  const formatValue = (value: any) => {
    return `${value.vendorName} ${value.vendorCode}`;
  };
  const onValueSelectedHandler = (vendor: Vendor | null) => {
    onValueSelected(vendor);
    if (!vendor?.id) {
      setFilter({
        field: searchQuery?.filter?.field || PRICE_CONSTS.VENDOR,
        value: '',
      });
    }
  };
  useEffect(() => {
    if (value?.id) {
      setFilter({
        field: searchQuery?.filter?.field || PRICE_CONSTS.VENDOR,
        value: '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const dropdownOptions = useMemo(
    () => [
      {
        label: translate('Pricing.SinglePriceSearchFilterVendor'),
        value: PRICE_CONSTS.VENDOR,
      },
    ],
    [translate]
  );
  return (
    <CustomSearchBar
      disabled={!!value}
      dropdownOptions={dropdownOptions}
      formatValue={formatValue}
      isLoading={isLoading}
      onDropdownOptionChange={({ value: field }) => {
        setFilter({
          field,
          value: '',
        });
      }}
      onRemoveSelected={() => {
        onValueSelectedHandler(null);
      }}
      onSearch={(data: any) => {
        setFilter({
          field: searchQuery?.filter?.field || PRICE_CONSTS.VENDOR,
          value: data.inputValue,
        });
      }}
      onValueSelected={onValueSelectedHandler}
      options={list || []}
      placeholder={translate(`Pricing.SinglePriceSearchPlaceholderVendor`)}
      renderValue={formatValue}
      selectedValue={value}
      value={searchQuery?.filter?.value}
    />
  );
}
